import httpReq from '@/server/http'

const httpRequest = {
  // **************************公共 start*************
  publicUploadImage: function (params) {
    var url = '/api/v1/upload/image';


    return httpReq(url, 'postfile', params.file);
  },
  // **************************公共 end****************
  // **************************登录注册 start****************
  // 上传用户图片
  uploadImage: function (params) {
    var url = '/api/v1/upload/user-image';

    return httpReq(url, 'postfile', params.file);
  },
  // 系统基础配置*******strat*********
  // type：    after_sales_reason 售后理由   mall_goods_sale_server  商品销售服务
  getAfterSaleApplyReason: function (params) {
    var url = '/api/v1/config/custom-field';

    return httpReq(url, 'GET', params);
  },
  // 获取考级报名考场考点
  getCustomField: function (params) {
    var url = '/api/v1/config/custom-field';

    return httpReq(url, 'GET', params);
  },
  getCipherPublicKey: function (params) {
    var url = '/api/v1/common/rsa/public-key';

    return httpReq(url, 'POST', params);
  },
  // 系统基础配置*******end*********

  // **************************登录注册 end****************
  // **************************登录注册 start****************
  // 登录
  userLogin: function (params) {
    var url = '/api/v1/auth/token';

    return httpReq(url, 'GET', params);
  },
  // 三方登录
  socialLogin: function (params) {
    var url = '/api/v1/auth/socialite-login';

    return httpReq(url, 'POST', params);
  },
  // 三方绑定
  socialBind: function (params) {
    var url = '/api/v1/auth/socialite-bind';

    return httpReq(url, 'POST', params);
  },
  // 绑定微信qq微博
  thirdBind: function (params) {
    var url = '/api/v1/auth/user/socialite-bind';

    return httpReq(url, 'POST', params);
  },
  // 获取用户信息
  getUserInfo: function () {
    var url = '/api/v1/auth/user';

    return httpReq(url, 'GET');
  },
  // 发送验证码
  sendVerifyCode: function (params) {
    var url = '/api/v1/auth/send-verify-code';

    return httpReq(url, 'post', params);
  },
  // 注册
  userRegister: function (params) {
    var url = '/api/v1/auth/register';

    return httpReq(url, 'post', params);
  },
  // 找回密码
  findPassword: function (params) {
    var url = '/api/v1/auth/find-pwd';

    return httpReq(url, 'post', params);
  },
  // **************************登录注册 end****************

  //**************************首页 start****************
  // 获取首页信息
  getMainPageShowDetail: function (params) {
    var url = '/api/v1/page/detail';

    return httpReq(url, 'GET', params);
  },
  // 获取课程分类列表
  getCourseCategoryList: function (params) {
    var url = '/api/v1/course/cate';

    return httpReq(url, 'GET', params);
  },
  // 获取课程分类详情
  getCourseClassDetailList: function (params) {
    var url = '/api/v1/course/cate/detail';

    return httpReq(url, 'GET', params);
  },
  // 获取名家分类列表
  getMastersCategoryList: function (params) {
    var url = '/api/v1/course/master-teacher/cate';

    return httpReq(url, 'GET', params);
  },
  // 获取名家分类详情
  getMarstersClassDetailList: function (params) {
    var url = '/api/v1/course/master-teacher/cate/detail';

    return httpReq(url, 'GET', params);
  },
  //  获取商品分类列表
  getMallGoodsCategoryList: function (params) {
    var url = '/api/v1/mall/goods/cate';

    return httpReq(url, 'GET', params);
  },
  // 获取商品分类详情
  getMallGoodsClassDetailList: function (params) {
    var url = '/api/v1/mall/goods/cate/detail';

    return httpReq(url, 'GET', params);
  },
  // 获取热门搜索列表
  getHotSearchList: function (params) {
    var url = '/api/v1/common/search/hot-keywords';

    return httpReq(url, 'GET', params);
  },

  // 首页更多***********
  // 获取课程列表
  getCourseList: function (params) {
    var url = '/api/v1/course';

    return httpReq(url, 'GET', params);
  },
  // 资讯列表
  getInfomationList: function (params) {
    var url = '/api/v1/information';

    return httpReq(url, 'GET', params);
  },
  // 获取商品列表
  getMallGoodsInfoList: function (params) {
    var url = '/api/v1/mall/goods';

    return httpReq(url, 'GET', params);
  },
  // 获取名家列表
  getMarstersList: function (params) {
    var url = '/api/v1/course/master-teacher';

    return httpReq(url, 'GET', params);
  },
  // 获取更多考级报名
  getMoreLevelExam: function (params) {
    var url = '/api/v1/level-exam';

    return httpReq(url, 'GET', params);
  },
  //**************************首页 end****************

  //**************************分享 start****************
  getShareInfo: function (params) {
    var url = '/api/v1/app/public/share';

    return httpReq(url, 'GET', params);
  },
  //**************************分享 end****************

  // **************************资讯相关 start****************
  // 获取资讯详情
  getInformationDetail: function (params) {
    var url = '/api/v1/information/detail';

    return httpReq(url, 'GET', params);
  },
  // 获取资讯报名验证码
  getVerificationCode: function (params) {
    var url = '/api/v1/information/apply/verify-code';

    return httpReq(url, 'POST', params);
  },
  // 提交活动报名
  submitActivityInfor: function (params) {
    var url = '/api/v1/information/apply';

    return httpReq(url, 'POST', params);
  },


  //**************************资讯相关 end****************

  //**************************名家相关 strat****************
  // 获取名家详情
  getMastersDetail: function (params) {
    var url = '/api/v1/course/master-teacher/detail';

    return httpReq(url, 'GET', params);
  },

  //************************** 名家相关 end****************

  // **************************课程相关 strat****************
  // 获取课程详情
  getCourseDetail: function (params) {
    var url = '/api/v1/course/detail';

    return httpReq(url, 'GET', params);
  },
  recordCourseFootprint: function (params) {
    var url = '/api/v1/auth/user/course/study-record';

    return httpReq(url, 'POST', params);
  },
  getCoursePackageCourseList: function(params) {
    var url = '/api/v1/course/detail/course-package';

    return httpReq(url, 'get', params);
  },
  // **************************课程相关 end****************
  //  ****************************** 群组 start******************************
  getGroupDetailInfo: function (params) {
    var url = '/api/v1/course/group';

    return httpReq(url, 'GET', params);
  },
  getGroupHistoryMessage: function (params) {
    var url = '/api/v1/course/group/message';

    return httpReq(url, 'GET', params);
  },
  getGroupMemberList: function (params) {
    var url = '/api/v1/course/group/member';

    return httpReq(url, 'GET', params);
  },
  sendGroupChatMessageInfo: function (params) {
    return httpReq("/api/v1/course/group/message", "POST", params);
  },
  uploadMessageImage: function (params) {
    var url = '/api/v1/course/group/message/upload-image';

    return httpReq(url, 'postfile', params);
  },
  setCourseGroupInfo: function (params) {
    return httpReq("/api/v1/course/group/update", "POST", params);
  },
  setMyGroupMemberInfo: function (params) {
    return httpReq("/api/v1/auth/user/course/group/member/update", "POST", params);
  },
  getGroupPresetBackground: function (params) {
    var url = '/api/v1/config/image-resource';

    return httpReq(url, 'GET', params);
  },
  //  ****************************** 群组 end*********************************
  // **************************商品相关 strat****************
  // 获取商品列表
  getGoodsList: function (params) {
    var url = '/api/v1/mall/goods';

    return httpReq(url, 'GET', params);
  },
  // 获取商品详情
  getGoodsDetail: function (params) {
    var url = '/api/v1/mall/goods/detail';

    return httpReq(url, 'GET', params);
  },
  // 获取商品评价列表
  getEvaluationList: function (params) {
    var url = '/api/v1/order/mall-goods-order/comment';

    return httpReq(url, 'GET', params);
  },

  // **************************商品相关 end****************

  // **************************我的相关 strat****************


  // **************************个人中心 strat****************
  // 获取消息列表
  getMessageCenter: function (params) {
    var url = '/api/v1/auth/user/message';

    return httpReq(url, 'GET', params);
  },
  // 标记已读
  messageTagHasBeenRead: function (params) {
    var url = '/api/v1/auth/user/message/read';

    return httpReq(url, 'POST', params);
  },
  // 删除消息
  delAllMessage: function (params) {
    var url = '/api/v1/auth/user/message';

    return httpReq(url, 'DELETE', params);
  },
  // 获取消息详情
  getMessageDetail: function (params) {
    var url = '/api/v1/auth/user/message/detail';

    return httpReq(url, 'GET', params);
  },
  // 更新个人信息
  updatePersonalData: function (params) {
    var url = '/api/v1/auth/user/update';

    return httpReq(url, 'POST', params);
  },
  // 更新用户头像
  updateAvatar: function (params) {
    var url = '/api/v1/auth/user/avatar';

    return httpReq(url, 'postfile', params.file);
  },
  // 获取文案详情
  getDocumentDetail: function (params) {
    var url = '/api/v1/common/document';

    return httpReq(url, 'GET', params);
  },
  // 意见反馈类型列表
  getFeedbackTypeList: function (params) {
    var url = '/api/v1/config/custom-field';

    return httpReq(url, 'GET', params);
  },
  // 提交意见反馈
  submitFeedback: function (params) {
    var url = '/api/v1/common/feedback';

    return httpReq(url, 'POST', params);
  },
  // 常见问题列表
  getCommonIssueList: function (params) {
    var url = '/api/v1/content/question';

    return httpReq(url, 'GET', params);
  },
  // 常见问题详情
  getCommonIssueDetail: function (params) {
    var url = '/api/v1/content/question/detail';

    return httpReq(url, 'GET', params);
  },
  // start-up接口
  getStartupData: function (params) {
    var url = '/api/v1/app/system/start-up';

    return httpReq(url, 'GET', params);
  },
  // 全局搜索
  searchByKeywords: function (params) {
    var url = '/api/v1/common/search';

    return httpReq(url, 'GET', params);
  },
  // 获取我的收藏
  getCollectListByType: function (params) {
    var url = '/api/v1/auth/user/store';

    return httpReq(url, 'GET', params);
  },
  // 删除我的收藏
  cancelCollectResourceByType: function (params) {
    var url = '/api/v1/auth/user/store';

    return httpReq(url, 'DELETE', params);
  },

  // 收藏资讯课程商品
  collectSource: function (params) {
    var url = '/api/v1/auth/user/store';

    return httpReq(url, 'POST', params);
  },

  // 我的课程列表
  getMyCourseList: function (params) {
    var url = '/api/v1/auth/user/course';

    return httpReq(url, 'GET', params);
  },
  // 我的正在学习的课程列表
  getStudingCourseList: function (params) {
    var url = '/api/v1/auth/user/course/study-record';

    return httpReq(url, 'GET', params);
  },

  // 支付明细
  getWalletRecord: function (params) {
    var url = '/api/v1/wallet/record';

    return httpReq(url, 'GET', params);
  },
  // 确认钱包订单充值
  confirmRechargeOrder: function (params) {
    return httpReq("/api/v1/order/wallet-order", "POST", params);
  },
  // 订单支付
  getPayParametersByPayType: function (params) {
    var url = '/api/v1/order/pay';

    return httpReq(url, 'POST', params);
  },
  // 提现配置信息
  getWithDrawDepositConfigInfo: function (params) {
    var url = '/api/v1/wallet/with_draw/config/detail';

    return httpReq(url, 'GET', params);
  },
  //提现
  sureWithdrawDeposit: function (params) {
    var url = '/api/v1/wallet/with_draw';

    return httpReq(url, 'POST', params);
  },
  // 余额支付
  walletPayment: function (params) {
    var url = '/api/v1/wallet/pay';

    return httpReq(url, 'POST', params);
  },
  checkPaymentResultStatus: function (params) {
    var url = '/api/v1/pay/result';

    return httpReq(url, 'GET', params);
  },
  // *********************** 我的考级报名start***********************
  //获取考生编号
  getExamStudentCode: function (params) {
    var url = '/api/v1/level-exam/student-code';

    return httpReq(url, 'GET', params);
  },
  // 获取考级报名验证码
  getExamSignUpVerificationCode: function (params) {
    var url = '/api/v1/level-exam/apply/valid';

    return httpReq(url, 'POST', params);
  },
  //保存考生考级报名信息
  saveRegisterDistinction: function (params) {
    var url = '/api/v1/level-exam/apply';

    return httpReq(url, 'POST', params);
  },
  // 删除考生保存信息
  deleteRegisterDistinction: function (params) {
    var url = '/api/v1/level-exam/apply';

    return httpReq(url, 'DELETE', params);
  },
  // 提交等级考试报名信息
  submitExamInforamtion: function (params) {
    var url = '/api/v1/level-exam/apply/update';

    return httpReq(url, 'POST', params);
  },
  // 获取我的考级报名列表
  getExaminationSignUp: function (params) {
    var url = '/api/v1/auth/user/level-exam';

    return httpReq(url, 'GET', params);
  },
  // 获取我的考级报名详情
  getExaminationSignUpDetail: function (params) {
    var url = '/api/v1/level-exam/detail';

    return httpReq(url, 'GET', params);
  },
  // 获取我的考级报名申请列表
  getExaminationApplyList: function (params) {
    var url = '/api/v1/level-exam/apply';

    return httpReq(url, 'GET', params);
  },
  // 考级报名详情表单
  getExaminationApplyDetailFrom: function (params) {
    var url = '/api/v1/level-exam/apply/detail';

    return httpReq(url, 'GET', params);
  },
  // *********************** 我的考级报名end***********************


  // **************************个人中心 end****************

  // **************************商城 strat****************
  // 我的订单列表
  getOrderList: function (params) {
    var url = '/api/v1/order';

    return httpReq(url, 'GET', params);
  },
  // 订单详情接口
  getOrderDetail: function (params) {
    var url = '/api/v1/order/detail';

    return httpReq(url, 'GET', params);
  },
  //关闭取消订单
  colseOrder: function (params) {
    var url = '/api/v1/order/close';

    return httpReq(url, 'POST', params);
  },
  // 删除订单
  deleteOrder: function (params) {
    var url = '/api/v1/auth/user/order';

    return httpReq(url, 'DELETE', params);
  },
  // 评价订单
  evaluationOrder: function (params) {
    var url = '/api/v1/order/mall-goods-order/comment/many';

    return httpReq(url, 'POST', params);
  },
  // 确认收货
  sureAcceptGoods: function (params) {
    var url = '/api/v1/order/confirm-receipt';

    return httpReq(url, 'POST', params);
  },
  // 购物车列表
  getShoppingCartList: function (params) {
    var url = '/api/v1/auth/user/cart';

    return httpReq(url, 'GET', params);
  },
  // 更新购物车
  updateShoppingCart: function (params) {
    var url = '/api/v1/auth/user/cart/update';

    return httpReq(url, 'POST', params);
  },
  // 操作购物车
  changeShoppingCart: function (params) {
    var url = '/api/v1/auth/user/cart';

    return httpReq(url, 'POST', params);
  },
  // 删除购物车
  deleteShoppingCart: function (params) {
    var url = '/api/v1/auth/user/cart';

    return httpReq(url, 'delete', params);
  },
  // 确认订单
  confirmOrder: function (params) {
    var url = '/api/v1/order';

    return httpReq(url, 'post', params);
  },
  // 物流信息列表
  getLogisticsInfor: function (params) {
    var url = '/api/v1/order/logistics-logs';

    return httpReq(url, 'GET', params);
  },
  // 上传（申请售后 物流）图片
  upLoadPicture: function (params) {
    // var url = '/api/v1/upload/user-image';

    // return httpReq(url, 'POST', null , function (req) {
    //   req.attach('file', params.file);
    // });
    var url = '/api/v1/upload/user-image';

    return httpReq(url, 'postfile', params.file);

  },
  // 申请售后
  submmitSaleAfter: function (params) {
    var url = '/api/v1/order/return';

    return httpReq(url, 'POST', params);
  },
  // 提交物流信息 
  submitLogisticsInfo: function (params) {
    var url = '/api/v1/order/return/send';

    return httpReq(url, 'POST', params);
  },

  // 物流公司接口
  getAllLogisCompany: function (params) {
    var url = '/api/v1/config/express';

    return httpReq(url, 'GET', params);
  },

  // 售后列表
  getAfterSaleList: function (params) {
    var url = '/api/v1/order/return';

    return httpReq(url, 'GET', params);
  },
  // 删除售后
  deleteAfterSale: function (params) {
    var url = '/api/v1/order/return';

    return httpReq(url, 'DELETE', params);
  },

  // 售后详情
  getAfterSaleDetail: function (params) {
    var url = '/api/v1/order/return/detail';

    return httpReq(url, 'GET', params);
  },

  // 我的发票
  reqInvoiceList: function (params) {
    var url = '/api/v1/auth/user/invoice-config';

    return httpReq(url, 'GET', params);
  },
  // 新建发票
  setUpInvoice: function (params) {
    var url = '/api/v1/auth/user/invoice-config';

    return httpReq(url, 'POST', params);
  },
  // 删除发票
  deleteInvoiceInfo: function (params) {
    var url = '/api/v1/auth/user/invoice-config';

    return httpReq(url, 'DELETE', params);
  },
  // 修改发票为默认
  changeDefaultInvoice: function (params) {
    var url = '/api/v1/auth/user/invoice-config/update';

    return httpReq(url, 'POST', params);
  },

  // 获取地址列表
  reqAddressList: function (params) {
    var url = '/api/v1/auth/user/shipping-address';

    return httpReq(url, 'GET', params);
  },
  // 修改地址为默认地址
  changeDefaultAddress: function (params) {
    var url = '/api/v1/auth/user/shipping-address/update';

    return httpReq(url, 'POST', params);
  },
  // 删除地址
  deleteAddressInfo: function (params) {
    var url = '/api/v1/auth/user/shipping-address';

    return httpReq(url, 'DELETE', params);
  },
  // 修改地址为默认
  changeDefaultAddress: function (params) {
    var url = '/api/v1/auth/user/shipping-address/update';

    return httpReq(url, 'POST', params);
  },
  // 新建地址
  setUpAddress: function (params) {
    var url = '/api/v1/auth/user/shipping-address';

    return httpReq(url, 'POST', params);
  },

  // 获取我的评价列表
  getMyEvaluationList: function (params) {
    var url = '/api/v1/auth/user/mall-goods-order/comment';

    return httpReq(url, 'GET', params);
  },

  // 订单评价详情
  getOrderEvalateDetail: function (params) {
    var url = '/api/v1/order/detail';

    return httpReq(url, 'GET', params);
  },
  // **************************商城 end****************

  // **************************系统 strat****************
  // 获取关于详情
  getAboutUsDetail: function (params) {
    var url = '/api/v1/common/document';

    return httpReq(url, 'GET', params);
  },
  // 获取更换手机邮箱验证码
  reqSetVerifyCode: function (params) {
    var url = '/api/v1/auth/user/send-verify-code';

    return httpReq(url, 'POST', params);
  },
  // **************************系统 end****************

  // **************************我的相关 end****************
}

export default httpRequest



// WEBPACK FOOTER //
// ./src/server/http-api.js